import FieldSearch from './fieldSearch';

export default FieldSearch.extend({
  className: 'grid-fuzzy',
  filter(field, value, model) {
    let regex;
    try {
      regex = new RegExp(`.*(${value}).*`, 'i');
    } catch (e) {
      return false;
    }

    // below code is suggested by eslint role "guard-for-in".
    for (const key in model.attributes) {
      if (model.attributes.hasOwnProperty(key)) {
        const val = model.attributes[key];
        if (val.search && val.search(regex) > -1) {
          return true;
        }
      }
    }
    return false;
  }
});
